import React from "react";
import { useReplaceSmartboxMutation } from "../../hooks/use_site";
import { useModal } from "../../context/modal_provider";
import DialogForm from "../material_react_table/dialog_form";
import { FORM_ACTIONS } from "../../enums/form_actions_enum";

export function useReplaceSmartboxDialog() {
  const { openDialogModal } = useModal();

  return (siteData) => {
    openDialogModal({
      dialogTabs: [
        {
          label: "Replace Smartbox",
          component: <ReplaceSmartboxDialog siteData={siteData} />,
        },
      ],
    });
  };
}

export function ReplaceSmartboxDialog({ siteData }) {
  const { closeDialogModal } = useModal();
  const { mutate: replaceSmartbox, isPending } = useReplaceSmartboxMutation({
    onSuccess: () => {
      closeDialogModal();
    },
  });

  return (
    <DialogForm
      dialogAction={FORM_ACTIONS.REPLACE_SMARTBOX}
      selectedRow={siteData}
      onClose={closeDialogModal}
      isPending={isPending}
      handleConfirm={(data, action, dialogData) =>
        replaceSmartbox({
          siteId: data["site_id"],
          boxId: dialogData["box_id"],
        })
      }
    />
  );
}
